import {Component} from '@angular/core';

@Component({
    selector: 'app-core-team-section',
    templateUrl: './core-team-section.component.html',
    styleUrls: ['./core-team-section.component.css', '../../../assets/styles/new-styles.css']
})
export class CoreTeamSectionComponent {
}
